export const createAffirmComponent = (pageType, price, learnMoreShow = true) => {
  const options = {
    pageType,
    // The product price amount passed to display loan price specific messaging. Value in USD cents (e.g. $100 = 10000)
    amount: price * 100,
    learnMoreShow,
  };

  return window.affirm.ui.components.create('promo', options);
};
